// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__veZtG","comment":"styles_comment__3Zujh"};